"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = Card;
exports.default = void 0;
var _core = require("@blueprintjs/core");
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _classes = require("../../common/classes");
var _paddingLevel = require("../../common/paddingLevel");
var _excluded = ["children", "className", "paddingClassName"],
  _excluded2 = ["cardInnerProps", "children", "className", "condensed", "elevated", "level", "padded", "paddingLevel", "interactive"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function CardInner(_ref) {
  var children = _ref.children,
    className = _ref.className,
    paddingClassName = _ref.paddingClassName,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = (0, _classnames.default)(_classes.Classes.CARD_INNER, paddingClassName, className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, props), children);
}
function Card(_ref2) {
  var cardInnerProps = _ref2.cardInnerProps,
    children = _ref2.children,
    className = _ref2.className,
    condensed = _ref2.condensed,
    elevated = _ref2.elevated,
    level = _ref2.level,
    padded = _ref2.padded,
    paddingLevel = _ref2.paddingLevel,
    interactive = _ref2.interactive,
    cardProps = _objectWithoutProperties(_ref2, _excluded2);
  /**
   * This exists to handle the fact that the `condensed` and `padded` props have been replaced
   * by the `paddingLevel` prop. We prioritise the paddingLevel prop but still need to
   * take into account the deprecated ones
   */
  var paddingClassName = _classes.Classes.paddingLevelClass(_paddingLevel.PaddingLevel.REGULAR);
  if (paddingLevel) {
    paddingClassName = _classes.Classes.paddingLevelClass(paddingLevel);
  } else if (padded !== undefined && !padded) {
    paddingClassName = _classes.Classes.paddingLevelClass(_paddingLevel.PaddingLevel.NONE);
  } else if (condensed) {
    paddingClassName = _classes.Classes.paddingLevelClass(_paddingLevel.PaddingLevel.CONDENSED);
  }
  var classes = (0, _classnames.default)(_classes.Classes.cardLevelClass(level), className);

  /**
   * If its interactive we want to ensure that the browser knows to treat it like a button
   * so we get visible focus states etc
   */
  var interactiveClasses = interactive ? {
    interactive: true,
    role: 'button',
    tabIndex: 0
  } : {};
  return /*#__PURE__*/React.createElement(_core.Card, _extends({}, cardProps, {
    className: classes,
    elevation: elevated ? _core.Elevation.ONE : _core.Elevation.ZERO
  }, interactiveClasses), /*#__PURE__*/React.createElement(CardInner, _extends({}, cardInnerProps, {
    paddingClassName: paddingClassName
  }), children));
}
var _default = Card;
exports.default = _default;